import { render, staticRenderFns } from "./ModalReassignReviewer.vue?vue&type=template&id=70754cb0"
import script from "./ModalReassignReviewer.vue?vue&type=script&lang=js"
export * from "./ModalReassignReviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports